import React, { useContext, useEffect, useState } from "react";
import Navbar from "../../../../common/layout/Navbar";
import {
  ConfigLabels,
  LicenseTypes,
  Operation,
  empType,
} from "../../../../../utils/Enum.types";
import { payloadTypes } from "../../../../../context/reducer";
import DataFetch from "../../../../../images/OpenIcon.svg";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import EmplayeeSelect from "../../../../../customComponents/EmplayeeSelect";
import { EmpMaster, EmpQueryType } from "../queries/types";
import { AppContext } from "../../../../../context/context";
import { Title } from "../../../../../stories/Title/Title";
import MessageModal from "../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../pages/LoadingModal";
import Modal from "react-modal";
import UsersList from "../Index";
import { AddModalStyles } from "../../../../../styles/CustomModalStyles";
import { emptyMessage } from "../../../../../utils/constants";
import { useLazyQuery, useMutation } from "@apollo/client";
import { nodeVar } from "../../../../../utils/commonQueryTypes";
import { GetEmployee } from "../AssignRights/queries/queries";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import useSwConfigData from "../../../../../customHooks/useSwConfigData";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import {
  ResetEmpPasswordResult,
  ResetEmpPasswordVar,
  SwConfigStrValueType,
} from "./queries/types";
import { ResetEmpPassword } from "./queries/mutations";
import {
  GetSwConfigVariablesResult,
  GetSwConfigVariablesVar,
  SwConfigQueryType,
} from "../../masters/items/configurations/queries/type";
import { GetSwConfigVariables } from "../../masters/items/configurations/queries/queries";
import { validatePassword } from "../../../../../utils/UtilFunctions";

const ResetUserPassword = () => {
  const { state, dispatch } = useContext(AppContext);
  const [modalFlag, setModalFlag] = useState(false);
  const [message, setMessage] = useState(emptyMessage);

  const [resetPassword, setResetPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const initialEmpDetails = {
    empId: 0,
    name: "",
    email: "",
    empType: "",
    mobile: "",
  };
  const [empDetails, setEmpDetails] = useState(initialEmpDetails);
  const navigate = useNavigate();
  const { user_details } = useLoggedInUserDetails();
  const { customer_id } = useUrlParams();

  const handleClose = () => {
    setMessage({
      message: "",
      flag: false,
      operation: Operation.NONE,
    });
  };

  const [getEmployee, { loading: GetEmployeeLoading }] = useLazyQuery<
    { node: EmpMaster },
    nodeVar
  >(GetEmployee);

  const [
    GetSwVariablesData,
    { data: SwConfigVariablesData, loading: GetSwConfigVariablesLoding },
  ] = useLazyQuery<GetSwConfigVariablesResult, GetSwConfigVariablesVar>(
    GetSwConfigVariables,
  );

  const [resetEmpPassword, { loading: ResetEmpPasswordLoading }] = useMutation<
    ResetEmpPasswordResult,
    ResetEmpPasswordVar
  >(ResetEmpPassword, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  useEffect(() => {
    if (state.empId)
      getEmployee({
        variables: {
          id: state.empId,
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setEmpDetails({
            empId: data.node.id,
            name: data.node.name,
            email: data.node.email,
            empType: data.node.empType,
            mobile: data.node.mobile,
          });
        }
      });
  }, [getEmployee, state.empId]);

  const HandleSubmit = async () => {
    if (customer_id) {
      resetEmpPassword({
        variables: {
          empID: state.empId,
          customerID: customer_id,
          user_details,
          password: resetPassword,
        },
      }).then(({ data }) => {
        if (data && data.ResetEmpPassword) {
          setMessage({
            flag: true,
            message: "Password updated successfully",
            operation: Operation.UPDATE,
          });
          dispatch({
            type: payloadTypes.SET_EMP_ID,
            payload: {
              empId: 0,
            },
          });
          setEmpDetails(initialEmpDetails);
          setResetPassword("");
        }
      });
    }
  };

  useEffect(() => {
    if (customer_id || state.customerId) {
      GetSwVariablesData({
        variables: {
          customerID: customer_id ? customer_id : state.customerId,
          input: {
            queryType: SwConfigQueryType.BY_CONFIG_KEY,
            strValue: [SwConfigStrValueType.EMP_DEFAULT_PASSWORD],
          },
        },
      }).then(({ data }) => {
        if (data) {
          setResetPassword(data.GetSwConfigVariables[0].str1Value);
        }
      });
    }
  }, [customer_id, state.customerId, GetSwVariablesData]);

  const [error, setError] = useState("");



  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const value = e.target.value;
    setResetPassword(value);

    // Update error message in real-time
    const errorMessage = validatePassword(value);
    setError(errorMessage);
  };

  return (
    <>
      <Navbar NavType={LicenseTypes.CUSTOMER_USERS} />
      <Title>Reset User Password</Title>
      <div className="assign-user-rights">
        <div className="row g-0 assign-user-rights__select-options">
          <div className="col-3">
            <div className="d-flex">
              <EmplayeeSelect
                label="Employee Name"
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_EMP_ID,
                      payload: {
                        empId: newValue.value,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_EMP_ID,
                      payload: {
                        empId: 0,
                      },
                    });
                    setEmpDetails(initialEmpDetails);
                  }
                }}
                onKeyDown={() => {}}
                value={state.empId ? state.empId : 0}
                empType={[empType.ACP]}
                queryType={EmpQueryType.ALL}
              />
              <img
                src={DataFetch}
                alt=""
                onClick={() => setModalFlag(!modalFlag)}
                className="data-fetch-icon"
              />
            </div>
            <TextField
              label="Mobile."
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              disabled
              value={empDetails.mobile}
              className="assign-user-rights__textfield"
            />
          </div>
          <div className="col-3">
            <div>
              <TextField
                label="Name."
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                disabled
                value={empDetails.name}
                className="assign-user-rights__textfield"
              />

              <TextField
                label="Type."
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                value={empDetails.empType}
                className="assign-user-rights__textfield"
                disabled
              />
            </div>
          </div>
          <div className="col-3">
            <TextField
              label="Email."
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              value={empDetails.email}
              className="assign-user-rights__textfield"
              disabled
            />
          </div>
        </div>
        <div className="row g-0 assign-user-rights__datablock">
          <div className="assign-user-rights__datablock--left">
            <div className="col-4">
              <TextField
                className="assign-user-rights__textfield"
                label="Password"
                value={resetPassword}
                onChange={handleChange}
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => {
                            setShowPassword(!showPassword);
                          }}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
                type={showPassword ? "text" : "password"}
              />
              {error && <span className="nodata">{error}</span>}
            </div>
          </div>
        </div>
        <Button mode="save" onClick={HandleSubmit} />
        <Button
          mode="back"
          onClick={() => {
            navigate(-1);
          }}
        />
      </div>

      <Modal isOpen={modalFlag} ariaHideApp={false} style={AddModalStyles}>
        <UsersList setModalFlag={setModalFlag} modalFlag={modalFlag} />
      </Modal>

      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />

      <LoadingModal flag={GetEmployeeLoading || ResetEmpPasswordLoading} />
    </>
  );
};

export default ResetUserPassword;
